import { Directive, ElementRef, Input, OnChanges, Renderer2 } from '@angular/core';
import { TypedChanges } from '@platform-frontend/util';
import { IconRegistryService } from '../icons';

@Directive({
  selector: '[yatSpinner]'
})
export class SpinnerDirective implements OnChanges {
  constructor(protected element: ElementRef<HTMLButtonElement>, private iconRegistryService: IconRegistryService, private renderer: Renderer2) {}

  @Input()
  hideContentWhileSpinning: boolean = false;

  @Input('yatSpinner')
  spinning: boolean = false;

  private stashedDisabledState: boolean | null = null;

  ngOnChanges(changes: TypedChanges<SpinnerDirective>): void {
    if (changes.spinning) {
      this.updateSpinner();
    }

    if (changes.spinning || changes.hideContentWhileSpinning) {
      this.updateHideContent();
    }
  }

  protected updateSpinner(): void {
    if (this.spinning) {
      this.renderer.addClass(this.element.nativeElement, 'with-spinner');
      this.element.nativeElement.appendChild(this.buildSpinner());
      this.stashAndForceDisabledState();
    } else {
      this.renderer.removeClass(this.element.nativeElement, 'with-spinner');
      this.element.nativeElement.querySelectorAll('.spinner').forEach(el => el.remove());
      this.unstashDisabledState();
    }
  }

  private buildSpinner(): HTMLSpanElement {
    const spinner: HTMLElement = this.renderer.createElement('span');
    spinner.classList.add('spinner');
    spinner.innerHTML = this.iconRegistryService.get('loader-light')?.data ?? '';
    return spinner;
  }

  private stashAndForceDisabledState(): void {
    this.stashedDisabledState = this.element.nativeElement.disabled;
    this.renderer.setProperty(this.element.nativeElement, 'disabled', true);
  }

  private unstashDisabledState(): void {
    if (this.stashedDisabledState !== null) {
      this.renderer.setProperty(this.element.nativeElement, 'disabled', this.stashedDisabledState);
      this.stashedDisabledState = null;
    }
  }

  protected updateHideContent(): void {
    if (this.spinning && this.hideContentWhileSpinning) {
      this.renderer.addClass(this.element.nativeElement, 'hide-content');
    } else {
      this.renderer.removeClass(this.element.nativeElement, 'hide-content');
    }
  }
}
